import { render, staticRenderFns } from "./StudentScriptLayout.vue?vue&type=template&id=c08de94a&scoped=true"
import script from "./StudentScriptLayout.vue?vue&type=script&lang=js"
export * from "./StudentScriptLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08de94a",
  null
  
)

export default component.exports